import { useEffect, useRef } from 'react';
import Plotly from 'plotly.js-dist';

const BarChartView = ({
  filteredData,
  selectedVariable,
  selectedMeasure,
  dataStructure,
  chartXAxis,
  showLegend,
  isSidebarOpen,
  variableDefinitions
}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current || !filteredData || filteredData.length === 0) {
      return;
    }

    // Group data by country and X-axis
    const groupedData = {};
    
    filteredData.forEach(row => {
      const country = row.Country;
      const xValue = chartXAxis === 'Year' ? row.Year : row.Country;
      
      if (!groupedData[country]) {
        groupedData[country] = { x: [], y: [] };
      }
      
      groupedData[country].x.push(xValue);
      groupedData[country].y.push(row.Value);
    });

    // Create traces for each country
    const traces = Object.keys(groupedData).map(country => ({
      x: groupedData[country].x,
      y: groupedData[country].y,
      type: 'bar',
      name: country,
      hovertemplate: `<b>${country}</b><br>` +
                    `${chartXAxis}: %{x}<br>` +
                    `${selectedMeasure}: %{y:,.2f}<br>` +
                    '<extra></extra>'
    }));

    const layout = {
      title: {
        text: selectedVariable || 'Select a Variable',
        font: { size: 18, family: 'Calibre-Light, Arial, sans-serif' }
      },
      xaxis: {
        title: chartXAxis,
        type: chartXAxis === 'Year' ? 'linear' : 'category'
      },
      yaxis: {
        title: selectedMeasure || 'Value'
      },
      barmode: 'group', // or 'stack' for stacked bars
      showlegend: showLegend,
      legend: {
        orientation: 'v',
        x: 1.05,
        y: 1
      },
      hovermode: 'closest',
      margin: { l: 60, r: 150, t: 80, b: 60 },
      autosize: true
    };

    const config = {
      responsive: true,
      displayModeBar: true,
      displaylogo: false,
      modeBarButtonsToRemove: ['lasso2d', 'select2d']
    };

    Plotly.newPlot(chartRef.current, traces, layout, config);

    // Handle window resize
    const handleResize = () => {
      if (chartRef.current) {
        Plotly.Plots.resize(chartRef.current);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);

  }, [filteredData, selectedVariable, selectedMeasure, chartXAxis, showLegend, isSidebarOpen]);

  return (
    <div style={{ width: '100%', height: '100%', padding: '1rem' }}>
      <div ref={chartRef} style={{ width: '100%', height: '100%' }} className="plotly-chart" />
    </div>
  );
};

export default BarChartView;